var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webcam-pic" }, [
    _c("img", {
      attrs: {
        src: _vm.imageUrl,
        alt: "Bild des Lechsees und der umliegenden Bergkette"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }